import React from 'react';
import { Trash2 } from 'lucide-react';

interface ClearButtonProps {
  onClear: () => void;
  label?: string;
}

export const ClearButton: React.FC<ClearButtonProps> = ({ 
  onClear, 
  label = 'Clear All' 
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onClear();
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-2 px-4 py-2 text-red-600 hover:text-red-800 transition-colors"
      title="Clear all records"
    >
      <Trash2 className="w-5 h-5" />
      {label}
    </button>
  );
};
